import createAxios from './api'
import store from '../../store'

const PATH_RDSS = '/v1/seal'

export default {
  async getSealStatus() {
    if (store.state.remoteConfig.rdssApiUrl && store.state.remoteConfig.rdssApiUrl.length > 0) {
      const axios = await createAxios()
      const resp = await axios.get(store.state.remoteConfig.rdssApiUrl + `${PATH_RDSS}/status`)
      return resp.data
    } else {
      const sealStatus = {
        enabled: false,
        secureMode: false,
        activated: false
      }
      return sealStatus
    }
  }

}
